<template>
	<v-alert type="info" variant="tonal" density="compact" class="mt-3">
		<div class="text-body-2">
			The report will be run {{ formattedDelay }} after the last item has finished uploading.
		</div>
	</v-alert>
</template>

<script setup lang="ts">
	import { computed } from "vue";
	import { formatDelayHuman } from "@/helpers/time";

	const props = defineProps<{
		delaySeconds?: number;
	}>();

	const formattedDelay = computed(() => formatDelayHuman(props.delaySeconds ?? 120));
</script>
